import React from "react";
import { Row, Col, Select } from "antd";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import styled from "styled-components";
import { SearchOutlined } from "@ant-design/icons";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  Tooltip as RechartsTooltip,
  PieChart,
  Pie,
  Cell,
} from "recharts";

import { CartesianGrid, XAxis, YAxis } from "recharts";
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const WrapperBox = styled.div`
  .container_dashboard_one {
    display: flex;
    gap: 20px;
    padding: 5px 5px 15px 5px;
  }
  .container_main_fordashboard {
    background-color: rgb(255, 255, 255);
    padding: 15px 15px 15px 15px;
    border-radius: 16px;
    border: 1px solid rgb(218, 218, 218);
    margin: 10px 0px 15px 0px;
  }

  .ant-select-selector {
    width: 300px !important;
  }
  .antv-chart-container canvas {
    background: white !important; 
  }
  .container_dashboard_two {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 4px 12px 4px;
  }
  p {
    font-size: 17px;
  }
  .antv_chart_container {
    margin: 20px 0px 20px 0px;
  }
  .three_forty_kms {
    margin-left: 6px;
    font-weight: 600;
    font-size: 18px;
  }
  .three__kms {
    margin-left: 3px;
    font-size: 12px;
  }
  .container_three {
    display: flex;
    width: 100%;
    gap: 20px;
    justify-content: space-evenly;
    padding: 12px 5px 12px 5px;
  }
  .container_three_sub {
    width: 30%;
    height: 150px;
    background-color: rgb(235, 255, 222);
    border-radius: 14px;
    padding: 5px 4px 5px 4px;
  }
  .Delivery_Rate {
    padding: 9px 04px 9px 04px;
    margin-left: 5px;
  }

  .container_sub_two {
    background-color: rgb(220, 248, 252);
  }
  .container_sub_three {
    background-color: rgb(255, 226, 247);
  }
  .twenty_one {
    text-align: center;
  }
  .container_forchart_bar {
    display: flex;
    width: 100%;
    height: 70vh;
  }
  .container_forchart_childcontainer_bar {
    width: 90%;
    max-width: 1300px;
    height: 30vh;
    min-height: 400px;
    max-height: 400px;
  }
  /* .doghnut_chart {
    display: flex;
    width: 100%;
    height: 50vh;
    justify-content: center;
  }
  .doghnut_chart_sub {
    width: 90%;
    max-width: 400px;
    height: 25vh;
    min-height: 350px;
    max-height: 400px;
  } */
`;

const AnalyticsDashboard = () => {
  const data = {
    labels: [
      "KA12345",
      "KA12345",
      "KA12345",
      "KA12345",
      "KA12345",
      "KA12345",
      "KA12345",
      "KA12345",
    ],
    datasets: [
      {
        label: "Actual Values",
        data: [18, 14, 20, 18, 16, 10, 20, 18],
        backgroundColor: "rgba(103,164,255)",
      },
    ],
  };
  const options = {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    indexAxis: "y",
    responsive: true,
    scales: {
      x: {
        grid: { display: false },
        border: { display: false },
        ticks: { display: true },
      },
      y: {
        grid: { display: false },
        border: { display: false },
        ticks: { display: true },
        color: (context) => {
          return context.tick.label === "KA12345"
            ? "rgb(135,145,169)"
            : "rgb(135,145,169)";
        },
      },
    },
    elements: {
      bar: {
        borderRadius: [5, 5, 5, 5],
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        barThickness: 20,
      },
    },
  };

  const dataone = [
    { name: "KA12345", value: 18 },
    { name: "KA12345", value: 6 },
    { name: "KA12345", value: 16 },
    { name: "KA12345", value: 2 },
    { name: "KA12345", value: 12 },
    { name: "KA12345", value: 4 },
    { name: "KA12345", value: 18 },
    { name: "KA12345", value: 2 },
    { name: "KA12345", value: 8 },
    { name: "KA12345", value: 3 },
    { name: "KA12345", value: 14 },
    { name: "KA12345", value: 4 },
    { name: "KA12345", value: 12 },
    { name: "KA12345", value: 6 },
    { name: "KA12345", value: 14 },
    { name: "KA12345", value: 4 },
    { name: "KA12345", value: 16 },
  ];
  const dataThree = {
    labels: [
      "KA12345",
      "KA12345",
      "KA12345",
      "KA12345",
      "KA12345",
      "KA12345",
      "KA12345",
      "KA12345",
    ],
    datasets: [
      {
        label: "Actual Values",
        data: [18, 14, 20, 18, 16, 10, 20, 18],
        backgroundColor: "rgba(192,144,255)",
      },
    ],
  };
  const optionsthree = {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    indexAxis: "y",
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        grid: { display: false },
        border: { display: false },
        ticks: { display: true },
      },
      y: {
        grid: { display: false },
        border: { display: false },
        ticks: { display: true },
        color: (context) => {
          return context.tick.label === "KA12345"
            ? "rgb(135,145,169)"
            : "rgb(135,145,169)";
        },
      },
    },
    elements: {
      bar: {
        borderRadius: [5, 5, 5, 5],
        categoryPercentage: 0.3,
        barPercentage: 0.09,
        barThickness: 11,
      },
    },
  };

  //   const datafive = {
  //     labels: [
  //       'Red',
  //       'Blue',
  //       'Yellow'
  //     ],
  //     datasets: [{
  //       label: 'My First Dataset',
  //       data: [200, 100],
  //       backgroundColor: [

  //         'rgb(107,103,235)',
  //         'rgb(255, 211, 97)',
  //       ],
  //       hoverOffset: 4
  //     }]
  //   };
  //   const optionsfive = {
  //     rotation: -90,
  //     circumference: 180, // Half circle
  //     cutout: "75%", // Adjust the hole size (optional)
  //     maintainAspectRatio: false,
  //     plugins: {
  //         legend: {
  //           display: false, // Removes the label behind the chart
  //         },
  //         tooltip: {
  //           enabled: true, // Ensures tooltip shows
  //           callbacks: {
  //             label: function (tooltipItem) {
  //               let dataset = tooltipItem.dataset;
  //               let value = dataset.data[tooltipItem.dataIndex]; // Get value
  //               return `Value: ${value}`; // Customize tooltip text
  //             },
  //           },
  //         },
  //       },

  //   };
  const datanew = [
    { name: "Red", value: 300, color: "rgb(107,103,235)" },
    { name: "Yellow", value: 100, color: "#FFD361" },
  ];

  const squareSize = 10;
  const lineLength = 30;
  const horizontalLineLength = 30;
  const textOffset = 5;

  const renderCustomLabel = ({ cx, cy, midAngle, outerRadius, index }) => {
    const RADIAN = Math.PI / 180;
    console.log("RADIAN--->", RADIAN);

    const isLeftSide = midAngle > 90;
    console.log("isleftside--->", isLeftSide);
    const x1 = cx + outerRadius * Math.cos(-midAngle * RADIAN);
    const y1 = cy + outerRadius * Math.sin(-midAngle * RADIAN);

    const x2 = x1 + lineLength * Math.cos(-midAngle * RADIAN);
    const y2 = y1 + lineLength * Math.sin(-midAngle * RADIAN);

    const x3 = isLeftSide
      ? x2 - horizontalLineLength
      : x2 + horizontalLineLength;
    const y3 = y2;

    return (
      <>
        <line
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke={datanew[index].color}
          strokeWidth={2}
        />

        <line
          x1={x2}
          y1={y2}
          x2={x3}
          y2={y3}
          stroke={datanew[index].color}
          strokeWidth={2}
        />

        <rect
          x={x3 - squareSize / 2}
          y={y3 - squareSize / 2}
          width={squareSize}
          height={squareSize}
          fill={datanew[index].color}
        />

        <text
          x={
            isLeftSide
              ? x3 - squareSize - textOffset
              : x3 + squareSize + textOffset
          }
          y={y3}
          fill="#333"
          textAnchor={isLeftSide ? "end" : "start"}
          dominantBaseline="central"
          fontSize={12}
        >
          {`${datanew[index].name} (${datanew[index].value})`}
        </text>
      </>
    );
  };

  return (
    <>
      <WrapperBox>
        <Row gutter={[24,24]}>
          <Col xl={12} className="container_main_fordashboard">
            <div className="container_dashboard_one">
              <h4>
                Total no of consingment
                <span> 67 </span>
              </h4>
            </div>
            <div className="container_dashboard_one">
              <Select
                className="kpireport_select_filter"
                showSearch
                prefix={
                  <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                }
                placeholder="Custom Range..."
                style={{ width: 220 }}
                suffixIcon={null}
              />
              <Select
                className="kpireport_select_filter"
                showSearch
                prefix={
                  <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                }
                placeholder="24th Aug 2024 - 24th Sep 2024"
                style={{ width: 220 }}
                suffixIcon={null}
              />
            </div>
            <div>
              <Bar data={data} options={options} />
            </div>
          </Col>
          <Col xl={12} sm={24} className="container_main_fordashboard">
            <div className="container_dashboard_one">
              <h4>
                Total no of consingment
                <span> 67 </span>
              </h4>
            </div>
            <div className="container_dashboard_one">
              <Select
                className="kpireport_select_filter"
                showSearch
                prefix={
                  <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                }
                placeholder="Custom Range..."
                style={{ width: 220 }}
                suffixIcon={null}
              />
              <Select
                className="kpireport_select_filter"
                showSearch
                prefix={
                  <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                }
                placeholder="24th Aug 2024 - 24th Sep 2024"
                style={{ width: 220 }}
                suffixIcon={null}
              />
            </div>
            <ResponsiveContainer width={700} height={300}>
              <PieChart>
                <Pie
                  data={datanew}
                  cx="45%"
                  cy="70%"
                  innerRadius={60}
                  outerRadius={100}
                  startAngle={180} // Starts from the left
                  endAngle={0} // Ends at the right
                  dataKey="value"
                  label={renderCustomLabel}
                >
                  {datanew.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </Col>

          <Col xl={24} sm={24} className="container_main_fordashboard">
            <div className="container_dashboard_two">
              <p>
                Total Fuel Consumption{" "}
                <b className="three_forty_kms">
                  250<sub className="three__kms">L</sub>{" "}
                </b>
              </p>
              <div className="container_dashboard_one">
                <Select
                  className=""
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="Custom Range..."
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
                <Select
                  className=""
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="24th Aug 2024 "
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
              </div>
            </div>

            <div className="antv_chart_container">
              <ResponsiveContainer width="100%" height={300}>
                <AreaChart data={dataone}>
                  <RechartsTooltip
                    cursor={{ stroke: "rgb(175,182,197)", strokeWidth: 1 }}
                  />

                  <XAxis
                    dataKey="name"
                    tickLine={false}
                    tick={{ fill: "rgb(175,182,197)", fontSize: 12 }}
                  />
                  <YAxis
                    domain={[0, 14]}
                    tickCount={15}
                    tickLine={false}
                    tick={{ fill: "rgb(175,182,197)", fontSize: 12 }}
                  />
                  <RechartsTooltip />
                  <Area
                    type="monotone"
                    dataKey="value"
                    stroke="rgb(251,188,72)"
                    fill="rgb(251,188,72)"
                  />
                  {/* <Area type="monotone" dataKey="value" stroke="rgb(251,188,72)" fill="rgb(246,228,197)" fillOpacity={1} />
 <Area type="monotone" dataKey="value" stroke="none" fill="rgb(247,207,135)" fillOpacity={1} />
 <Area type="monotone" dataKey="value" stroke="none" fill="rgb(246,216,160)" fillOpacity={0.5} />
    <Area type="monotone" dataKey="value" stroke="none" fill="rgb(246,225,195)" fillOpacity={0.4} />
    <Area type="monotone" dataKey="value" stroke="none" fill="rgb(247,238,222)" fillOpacity={0.1} /> */}
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Col>
          <Col xl={24} sm={24} className="container_main_fordashboard">
            <div className="container_dashboard_two">
              <p>
                Total Distance Traveled{" "}
                <b className="three_forty_kms">
                  345<sub className="three__kms">Kms</sub>{" "}
                </b>
              </p>
              <div className="container_dashboard_one">
                <Select
                  className=""
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="Custom Range..."
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
                <Select
                  className=""
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="24th Aug 2024 "
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
              </div>
            </div>

            <div className="antv_chart_container">
              <ResponsiveContainer width="100%" height={300}>
                <AreaChart data={dataone}>
                  <XAxis
                    dataKey="name"
                    tickLine={false}
                    tick={{ fill: "rgb(175,182,197)", fontSize: 12 }}
                  />
                  <YAxis
                    domain={[0, 14]}
                    tickCount={15}
                    tickLine={false}
                    tick={{ fill: "rgb(175,182,197)", fontSize: 12 }}
                  />
                  <RechartsTooltip />
                  <Area
                    type="monotone"
                    dataKey="value"
                    stroke="rgb(32,221,175)"
                    fill="rgb(188,237,225)"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Col>
          <Col xl={24} className="container_main_fordashboard">
            <div className="container_dashboard_two">
              <p>
                Average Mileage
                <b className="three_forty_kms">
                  67 <sub className="three__kms">Km/L</sub>
                </b>
              </p>
              <div className="container_dashboard_one">
                <Select
                  className="kpireport_select_filter"
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="Custom Range..."
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
                <Select
                  className="kpireport_select_filter"
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="24th Aug 2024 "
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
              </div>
            </div>

            <div className="container_forchart_bar">
              <div className="container_forchart_childcontainer_bar">
                <Bar data={dataThree} options={optionsthree} />
              </div>
            </div>
          </Col>
        </Row>
      </WrapperBox>

      {/* <WrapperBox>
        <Row>
          <Col xl={24} sm={24} className="container_main_fordashboard">
            <div className="container_dashboard_two">
              <p>
                Total Distance Traveled{" "}
                <b className="three_forty_kms">
                  345<sub className="three__kms">Kms</sub>{" "}
                </b>
              </p>
              <div className="container_dashboard_one">
                <Select
                  className=""
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="Custom Range..."
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
                <Select
                  className=""
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="24th Aug 2024 "
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
              </div>
            </div>

            <div className="antv_chart_container">
              <ResponsiveContainer width="100%" height={300}>
                <AreaChart data={dataone}>
                  <XAxis
                    dataKey="name"
                    tickLine={false}
                    tick={{ fill: "rgb(175,182,197)", fontSize: 12 }}
                  />
                  <YAxis
                    domain={[0, 14]}
                    tickCount={15}
                    tickLine={false}
                    tick={{ fill: "rgb(175,182,197)", fontSize: 12 }}
                  />
                  <RechartsTooltip />
                  <Area
                    type="monotone"
                    dataKey="value"
                    stroke="rgb(32,221,175)"
                    fill="rgb(188,237,225)"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Col>
        </Row>
      </WrapperBox> */}
      {/* <WrapperBox>
        <Row>
          <Col xl={24} sm={24} className="container_main_fordashboard">
            <div className="container_dashboard_two">
              <p>
                Total Fuel Consumption{" "}
                <b className="three_forty_kms">
                  250<sub className="three__kms">L</sub>{" "}
                </b>
              </p>
              <div className="container_dashboard_one">
                <Select
                  className=""
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="Custom Range..."
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
                <Select
                  className=""
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="24th Aug 2024 "
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
              </div>
            </div>

            <div className="antv_chart_container">
              <ResponsiveContainer width="100%" height={300}>
                <AreaChart data={dataone}>
                  <RechartsTooltip
                    cursor={{ stroke: "rgb(175,182,197)", strokeWidth: 1 }}
                  />

                  <XAxis
                    dataKey="name"
                    tickLine={false}
                    tick={{ fill: "rgb(175,182,197)", fontSize: 12 }}
                  />
                  <YAxis
                    domain={[0, 14]}
                    tickCount={15}
                    tickLine={false}
                    tick={{ fill: "rgb(175,182,197)", fontSize: 12 }}
                  />
                  <RechartsTooltip />
                  <Area
                    type="monotone"
                    dataKey="value"
                    stroke="rgb(251,188,72)"
                    fill="rgb(251,188,72)"
                  />
                 <Area type="monotone" dataKey="value" stroke="rgb(251,188,72)" fill="rgb(246,228,197)" fillOpacity={1} />
<Area type="monotone" dataKey="value" stroke="none" fill="rgb(247,207,135)" fillOpacity={1} />
 <Area type="monotone" dataKey="value" stroke="none" fill="rgb(246,216,160)" fillOpacity={0.5} />
    <Area type="monotone" dataKey="value" stroke="none" fill="rgb(246,225,195)" fillOpacity={0.4} />
    <Area type="monotone" dataKey="value" stroke="none" fill="rgb(247,238,222)" fillOpacity={0.1} /> 
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Col>
        </Row>
      </WrapperBox>  */}
      {/* 
      <WrapperBox>
        <Row>
          <Col xl={24} className="container_main_fordashboard">
            <div className="container_dashboard_two">
              <p>
                Average Mileage
                <b className="three_forty_kms">
                  67 <sub className="three__kms">Km/L</sub>
                </b>
              </p>
              <div className="container_dashboard_one">
                <Select
                  className="kpireport_select_filter"
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="Custom Range..."
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
                <Select
                  className="kpireport_select_filter"
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="24th Aug 2024 "
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
              </div>
            </div>

            <div className="container_forchart_bar">
              <div className="container_forchart_childcontainer_bar">
                <Bar data={dataThree} options={optionsthree} />
              </div>
            </div>
          </Col>
        </Row>
      </WrapperBox> */}
    </>
  );
};

export default AnalyticsDashboard;
